export const DEMO_TABLE_ID = 'I0gsCk1MfZLWXU9cEjCy';

export const CURRENCIES = {
  EURO: 1,
  DOLLAR: 2,
  ROUBLE: 3,
};
